import { webApi } from '@mi-front/api-clients';
import { Grid } from '@mui/material';
import { ProjectCard } from '../project-card/ProjectCard';

export interface FragmentVideoEditionsProjectGridProps {
  projects: webApi.EnrichedVideoEditorProjectListItemDto[];
  uploadsByPlatform: Map<string, webApi.FragmentSocialUploadItemDto[]> | undefined;
  onCloneProject: (project: webApi.EnrichedVideoEditorProjectListItemDto) => void;
}

/**
 * Responsive grid of project cards for the video editions tab.
 */
export function FragmentVideoEditionsProjectGrid({
  projects,
  uploadsByPlatform,
  onCloneProject,
}: FragmentVideoEditionsProjectGridProps) {
  return (
    <Grid container spacing={2}>
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          uploadsByPlatform={uploadsByPlatform}
          onClone={() => onCloneProject(project)}
        />
      ))}
    </Grid>
  );
}
